module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coding-box"
  }, [_c('div', {
    staticClass: "coding-content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "coding-bottom"
  }, [_c('span', {
    staticClass: "coding-title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note",
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coding-button"
  }, [_c('y-svg', {
    class: {
      top: _vm.codeShow
    },
    attrs: {
      "type": "arrow",
      "width": 16
    },
    nativeOn: {
      "click": function($event) {
        _vm.dom($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "code"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeShow),
      expression: "codeShow"
    }],
    staticClass: "coding-code"
  }, [_c('div', [_c('pre', [_c('code', {
    ref: "code",
    class: _vm.lang
  }, [_vm._v(_vm._s(_vm.code))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-19bb9fa7!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./doc/components/coding.vue
// module id = 454
// module chunks = 27